<template>
	<div grey-back full-height>

		<v-toolbar dark flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Update Opening Date</v-toolbar-title>
      		<!-- <v-spacer></v-spacer>
		    <v-btn round-borders outline @click="fn_saveOpeningDate">save</v-btn> -->
    	</v-toolbar>

	    <div class="hasToolbar" full-height white-background>

	    	<v-form>

	    		<v-layout row wrap pt-3 white-background>
	        		<v-flex xs12 sm12 md12 form-item @click="fn_openDialogDatePicker">
	        			<v-text-field  
			               	readonly
			               	:value="fn_fomattedOpeningDate()"
			               	label="Opening Date"
			               	placeholder=" " 
			               	append-icon="date_range">
		               </v-text-field>
	        		</v-flex>
	        	</v-layout>

	    	</v-form>

	    	<div white-background full-width nopadding style="position:fixed;bottom:0;">
				<v-layout row wrap>
					<v-flex xs12 sm12 md12 height48>
						<v-btn color="primary" full-height nomargin block no-round-borders noshadow @click="fn_saveOpeningDate">Save</v-btn>
					</v-flex>
				</v-layout>
			</div>

	    	

            <!-- <v-card noshadow margin-top-ten>
				<v-card-text>

					<div center-align>
		            	<div style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px">
		            		<v-icon class="primary-color" style="font-size:42px">date_range</v-icon>
		            	</div><br>

		            	<p class="title grey-color" style="line-height:28px !important">
		            		{{selectedDate | moment("DD-MMM-YYYY")}}
		            	</p>

		            	<div>
		            		<v-btn color="primary" @click="fn_openDialogDatePicker">
			               		Change
			               	</v-btn>
		            	</div>
		            </div>

				</v-card-text>
			</v-card> -->

	    </div>

	    <!-- <dialog-datepicker-opening ref="ref_dialogDatePickerOpening" :selected="openingDate" :updateDate="fn_updateDateOpening" :minDate="minDate" :maxDate="maxOpeningDate"></dialog-datepicker-opening> -->
	    <dialog-datepicker ref="ref_dialogDatePickerOpening" :selected="selectedDate" :updateDate="fn_updateDateOpening" :minDate="minDate" :maxDate="maxOpeningDate"></dialog-datepicker>

	</div>
</template>

<script>

// import {openingDateMixin} from '../opening_date_mixin'
import dialogDatePicker from './dialogs/dialog_datepicker'

	export default{
		// mixins: [openingDateMixin],
		data(){
			return{
				maxOpeningDate:null,
				// OpeningDate:null,
				minDate:"2022-04-01",//made change
				// selectedDate:new Date(JSON.parse(JSON.stringify(this.$root.CurrentBusiness.OpeningDate)))
				selectedDate:this.$root.CurrentBusiness.OpeningDate
			}
		},
		components:{
	      'dialog-datepicker':dialogDatePicker
	    },
		methods:{
			fn_fomattedOpeningDate: function(){
				return this.$moment(this.selectedDate).format('DD-MMM-YYYY');
			},

			fn_openDialogDatePicker: function(){
				this.$refs['ref_dialogDatePickerOpening'].openDialogWeb();
			},
			  
			fn_getFirstTransactionDate: function(){
				let self = this;
				let filterObject = {};
				// Sending opening stock and opening ledger list id to get first transaction date except these two.
				filterObject.transactionListId = [40001, 40003];
				this.getFilterData('FirstTransactionDate', null, filterObject,
					{
						onSuccess: function(response){
							console.log(response);
							let ftd = JSON.parse(response);
							let maxDate = null;

							if(!ftd){
								//Calculation of max date fy
								// let currentDate = new Date();
								// let currentMonth = currentDate.getMonth() + 1;
								// let currentYear = currentDate.getFullYear();

								// let year = null
								// year = currentMonth <= 3 ? currentYear : currentYear+1;

								// maxDate = new Date(year+"-03-31");

                                maxDate = new Date(self.$root.maxDateSelection);
							}
							else{
								maxDate = new Date(ftd);
							}

							console.log(maxDate);

							// Setting up min/max opening date selection
							self.fn_setupMinMaxOpeningDateSelection(maxDate)
							
						},
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_setupMinMaxOpeningDateSelection: function(maxDate){
				let year = this.$moment(maxDate).format('YYYY');
				let month = this.$moment(maxDate).format('MM');
				let day = this.$moment(maxDate).format('DD');

				this.maxOpeningDate = year+"-"+month+"-"+day;

				// let defaultOpeningDate = new Date(this.$root.CurrentBusiness.openingDate)
				// let currentDate = new Date();
				// let defaultOpeningDate = new Date((currentDate.getMonth() + 1) + '/1/' + currentDate.getFullYear());
				// let d_year = this.$moment(defaultOpeningDate).format('YYYY');
				// let d_month = this.$moment(defaultOpeningDate).format('MM');
				// let d_day = this.$moment(defaultOpeningDate).format('DD');

				// this.minDate = d_year+"-"+d_month+"-"+d_day;
			},

			fn_updateDateOpening: function(value){
				this.selectedDate = value;
				console.log(this.selectedDate);
			},

			fn_saveOpeningDate: function(){
				var self = this;

				let postObj = {};

				//subtracted 1 day from opening date as we are adding opening one day less than user selected opening date

				// postObj.OpeningDate = new Date(JSON.parse(JSON.stringify(this.selectedDate)));

				// setting up selected opening date as start of the day
				this.selectedDate = this.$moment(this.selectedDate).startOf('day');
				
				postObj.OpeningDate = this.$root.fn_getLocalDateFormat(this.selectedDate);
				postObj.BusinessID = this.$root.CurrentBusiness.BusinessID;

				// let od = new Date(JSON.parse(JSON.stringify(this.selectedDate)));
				let od = new Date(this.selectedDate);
				od.setDate(od.getDate()-1);
				// postObj.transactionDate = new Date(od);
				postObj.transactionDate = this.$root.fn_getLocalDateFormat(od);
				postObj.transactionListId = [40001, 40003];

				this.postData('OpeningDate', postObj, 
					{
						onSuccess: function(response){
							console.log(response);
							// self.OpeningDate = new Date(JSON.parse(JSON.stringify(self.selectedDate)));
							self.$root.CurrentBusiness.OpeningDate = new Date(JSON.parse(JSON.stringify(self.selectedDate)));
							self.$root.fn_setMinTransactionDate();
							self.fn_closeDialog();
							self.$router.go(-1);
							self.showToast('Opening date saved');
							// if(self.$route.query && self.$route.query.goback){
							// 	self.$router.go(-1);
							// }
						},
						onError: function(error){
							console.log(error);
							self.showToast('Something went wrong. Try again!.');
						}
					}
				);
			},

	      	fn_closeDialog: function(){
	      		this.$refs['ref_dialogDatePickerOpening'].closeDialogWeb();
	      	},

			fn_goBack: function(){
				this.$router.go(-1);
			},
		},
	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
			this.fn_getFirstTransactionDate();
	  	},
	  	beforeRouteLeave(to, from, next){
	      if(this.$refs['ref_dialogDatePickerOpening'].datepicker){
	        this.fn_closeDialog();
	        next(false);
	      }
	      else{
	        next();
	      }
	    },
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/opening_date/opening_date.vue